"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// @flow
var bignumber_js_1 = require("bignumber.js");
var taquito_1 = require("@taquito/taquito");
var ledger_signer_1 = require("@taquito/ledger-signer");
var utils_1 = require("@taquito/ledger-signer/dist/lib/utils");
var utils_2 = require("@taquito/utils");
var errors_1 = require("@ledgerhq/errors");
var shared_1 = require("../../../bridge/shared");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var account_1 = require("../../../account");
var synchronisation_1 = require("../synchronisation");
var bakers_1 = require("../bakers");
var env_1 = require("../../../env");
var signOperation_1 = require("../signOperation");
var operation_1 = require("../../../operation");
var logs_1 = require("@ledgerhq/logs");
var errors_2 = require("../../../errors");
var tzkt_1 = __importDefault(require("../api/tzkt"));
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
var EXISTENTIAL_DEPOSIT = new bignumber_js_1.BigNumber(275000);
var createTransaction = function () { return ({
    family: "tezos",
    mode: "send",
    amount: new bignumber_js_1.BigNumber(0),
    fees: null,
    gasLimit: null,
    storageLimit: null,
    recipient: "",
    networkInfo: null,
    useAllAmount: false,
    taquitoError: null,
    estimatedFees: null
}); };
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
var getTransactionStatus = function (account, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, resetTotalSpent, _a, recipientError, recipientWarning, estimatedFees, thresholdWarning, _b, result;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                errors = {};
                warnings = {};
                resetTotalSpent = false;
                if (!(t.mode !== "undelegate")) return [3 /*break*/, 3];
                if (!(account.freshAddress === t.recipient)) return [3 /*break*/, 1];
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, shared_1.validateRecipient)(account.currency, t.recipient)];
            case 2:
                _a = _c.sent(), recipientError = _a.recipientError, recipientWarning = _a.recipientWarning;
                if (recipientError) {
                    errors.recipient = recipientError;
                }
                if (recipientWarning) {
                    warnings.recipient = recipientWarning;
                }
                _c.label = 3;
            case 3:
                estimatedFees = t.estimatedFees || new bignumber_js_1.BigNumber(0);
                if (t.mode === "send") {
                    if (!errors.amount && t.amount.eq(0) && !t.useAllAmount) {
                        resetTotalSpent = true;
                        errors.amount = new errors_1.AmountRequired();
                    }
                    else if (t.amount.gt(0) && estimatedFees.times(10).gt(t.amount)) {
                        warnings.feeTooHigh = new errors_1.FeeTooHigh();
                    }
                    thresholdWarning = 0.5 * Math.pow(10, account.currency.units[0].magnitude);
                    if (!errors.amount &&
                        account.balance.minus(t.amount).minus(estimatedFees).lt(thresholdWarning)) {
                        if ((0, bakers_1.isAccountDelegating)(account)) {
                            if (t.useAllAmount) {
                                errors.amount = new errors_1.RecommendUndelegation();
                            }
                            else {
                                warnings.amount = new errors_1.RecommendUndelegation();
                            }
                        }
                    }
                }
                // effective amount
                // if we also have taquitoError, we interprete them and they override the previously inferred errors
                if (t.taquitoError) {
                    (0, logs_1.log)("taquitoerror", String(t.taquitoError));
                    // remap taquito errors
                    if (t.taquitoError.endsWith("balance_too_low")) {
                        if (t.mode === "send") {
                            resetTotalSpent = true;
                            errors.amount = new errors_1.NotEnoughBalance();
                        }
                        else {
                            errors.amount = new errors_1.NotEnoughBalanceToDelegate();
                        }
                    }
                    else if (t.taquitoError.endsWith("delegate.unchanged")) {
                        errors.recipient = new errors_2.InvalidAddressBecauseAlreadyDelegated();
                    }
                    else if (!errors.amount) {
                        // unidentified error case
                        errors.amount = new Error(t.taquitoError);
                        resetTotalSpent = true;
                    }
                }
                if (!errors.amount && account.balance.lte(0)) {
                    resetTotalSpent = true;
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                _b = !errors.amount &&
                    t.mode === "send" &&
                    t.amount.lt(EXISTENTIAL_DEPOSIT);
                if (!_b) return [3 /*break*/, 5];
                return [4 /*yield*/, tzkt_1["default"].getAccountByAddress(t.recipient)];
            case 4:
                _b = (_c.sent()).type === "empty";
                _c.label = 5;
            case 5:
                // Catch a specific case that requires a minimum amount
                if (_b) {
                    resetTotalSpent = true;
                    errors.amount = new errors_1.NotEnoughBalanceBecauseDestinationNotCreated("", {
                        minimalAmount: "0.275 XTZ"
                    });
                }
                result = {
                    errors: errors,
                    warnings: warnings,
                    estimatedFees: estimatedFees,
                    amount: t.amount,
                    totalSpent: resetTotalSpent
                        ? new bignumber_js_1.BigNumber(0)
                        : t.amount.plus(estimatedFees)
                };
                return [2 /*return*/, Promise.resolve(result)];
        }
    });
}); };
var prepareTransaction = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var tezosResources, recipientError, encodedPubKey, tezos, t, amount, out, _a, totalFees, maxAmount, gasBuffer, MINIMAL_FEE_PER_GAS_MUTEZ_1, increasedFee, incr, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                tezosResources = account.tezosResources;
                if (!tezosResources)
                    throw new Error("tezosResources is missing");
                if (account.balance.lte(0)) {
                    return [2 /*return*/, Promise.resolve(transaction)];
                }
                if (!(transaction.mode !== "undelegate")) return [3 /*break*/, 2];
                if (!transaction.recipient) {
                    return [2 /*return*/, Promise.resolve(transaction)];
                }
                return [4 /*yield*/, (0, shared_1.validateRecipient)(account.currency, transaction.recipient)];
            case 1:
                recipientError = (_b.sent()).recipientError;
                if (recipientError) {
                    return [2 /*return*/, Promise.resolve(transaction)];
                }
                _b.label = 2;
            case 2:
                encodedPubKey = (0, utils_2.b58cencode)((0, utils_1.compressPublicKey)(Buffer.from(account.xpub || "", "hex"), ledger_signer_1.DerivationType.ED25519), utils_2.prefix[utils_2.Prefix.EDPK]);
                tezos = new taquito_1.TezosToolkit((0, env_1.getEnv)("API_TEZOS_NODE"));
                tezos.setProvider({
                    signer: {
                        publicKeyHash: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, account.freshAddress];
                        }); }); },
                        publicKey: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, encodedPubKey];
                        }); }); },
                        sign: function () { return Promise.reject(new Error("unsupported")); },
                        secretKey: function () { return Promise.reject(new Error("unsupported")); }
                    }
                });
                t = __assign(__assign({}, transaction), { taquitoError: null });
                amount = transaction.amount;
                if (transaction.useAllAmount) {
                    amount = new bignumber_js_1.BigNumber(1); // send max do a pre-estimation with minimum amount (taquito refuses 0)
                }
                _b.label = 3;
            case 3:
                _b.trys.push([3, 12, , 13]);
                out = void 0;
                _a = transaction.mode;
                switch (_a) {
                    case "send": return [3 /*break*/, 4];
                    case "delegate": return [3 /*break*/, 6];
                    case "undelegate": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 4: return [4 /*yield*/, tezos.estimate.transfer({
                    mutez: true,
                    to: transaction.recipient,
                    amount: amount.toNumber(),
                    storageLimit: taquito_1.DEFAULT_STORAGE_LIMIT.ORIGINATION
                })];
            case 5:
                out = _b.sent();
                return [3 /*break*/, 11];
            case 6: return [4 /*yield*/, tezos.estimate.setDelegate({
                    source: account.freshAddress,
                    delegate: transaction.recipient
                })];
            case 7:
                out = _b.sent();
                return [3 /*break*/, 11];
            case 8: return [4 /*yield*/, tezos.estimate.setDelegate({
                    source: account.freshAddress
                })];
            case 9:
                out = _b.sent();
                return [3 /*break*/, 11];
            case 10: throw new Error("unsupported mode=" + transaction.mode);
            case 11:
                if (t.useAllAmount) {
                    totalFees = out.suggestedFeeMutez + out.burnFeeMutez;
                    maxAmount = account.balance
                        .minus(totalFees + (tezosResources.revealed ? 0 : taquito_1.DEFAULT_FEE.REVEAL))
                        .toNumber();
                    gasBuffer = 500;
                    MINIMAL_FEE_PER_GAS_MUTEZ_1 = 0.1;
                    increasedFee = function (gasBuffer, opSize) {
                        return gasBuffer * MINIMAL_FEE_PER_GAS_MUTEZ_1 + opSize;
                    };
                    incr = increasedFee(gasBuffer, Number(out.opSize));
                    t.fees = new bignumber_js_1.BigNumber(out.suggestedFeeMutez + incr);
                    t.gasLimit = new bignumber_js_1.BigNumber(out.gasLimit + gasBuffer);
                    t.amount = new bignumber_js_1.BigNumber(maxAmount - incr);
                }
                else {
                    t.fees = new bignumber_js_1.BigNumber(out.suggestedFeeMutez);
                    t.gasLimit = new bignumber_js_1.BigNumber(out.gasLimit);
                    t.storageLimit = new bignumber_js_1.BigNumber(out.storageLimit);
                }
                t.storageLimit = new bignumber_js_1.BigNumber(out.storageLimit);
                t.estimatedFees = t.fees;
                if (!tezosResources.revealed) {
                    t.estimatedFees = t.estimatedFees.plus(taquito_1.DEFAULT_FEE.REVEAL);
                }
                return [3 /*break*/, 13];
            case 12:
                e_1 = _b.sent();
                if (typeof e_1 !== "object" || !e_1)
                    throw e_1;
                if ("id" in e_1) {
                    t.taquitoError = e_1.id;
                    (0, logs_1.log)("taquito-error", "taquito got error " + t.taquitoError);
                }
                else if ("status" in e_1) {
                    // in case of http 400, log & ignore (more case to handle)
                    (0, logs_1.log)("taquito-network-error", String(e_1.message || ""), { transaction: t });
                    throw e_1;
                }
                else {
                    throw e_1;
                }
                return [3 /*break*/, 13];
            case 13:
                // nothing changed
                if (bnEq(t.estimatedFees, transaction.estimatedFees) &&
                    bnEq(t.fees, transaction.fees) &&
                    bnEq(t.gasLimit, transaction.gasLimit) &&
                    bnEq(t.storageLimit, transaction.storageLimit) &&
                    bnEq(t.amount, transaction.amount) &&
                    t.taquitoError === transaction.taquitoError) {
                    return [2 /*return*/, transaction];
                }
                return [2 /*return*/, t];
        }
    });
}); };
function bnEq(a, b) {
    return !a && !b ? true : !a || !b ? false : a.eq(b);
}
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, t, s;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    return [4 /*yield*/, prepareTransaction(mainAccount, __assign(__assign(__assign({}, createTransaction()), transaction), { 
                            // estimate using a burn address that exists so we don't enter into NotEnoughBalanceBecauseDestinationNotCreated
                            recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || "tz1burnburnburnburnburnburnburjAYjjX", useAllAmount: true }))];
                case 1:
                    t = _b.sent();
                    return [4 /*yield*/, getTransactionStatus(mainAccount, t)];
                case 2:
                    s = _b.sent();
                    return [2 /*return*/, s.amount];
            }
        });
    });
};
var broadcast = function (_a) {
    var _b = _a.signedOperation, operation = _b.operation, signature = _b.signature;
    return __awaiter(void 0, void 0, void 0, function () {
        var tezos, hash;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    tezos = new taquito_1.TezosToolkit((0, env_1.getEnv)("API_TEZOS_NODE"));
                    return [4 /*yield*/, tezos.contract.context.injector.inject(signature)];
                case 1:
                    hash = _c.sent();
                    return [2 /*return*/, (0, operation_1.patchOperationWithHash)(operation, hash)];
            }
        });
    });
};
var scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: synchronisation_1.getAccountShape });
var sync = (0, jsHelpers_1.makeSync)({ getAccountShape: synchronisation_1.getAccountShape });
var getPreloadStrategy = function (_currency) { return ({
    preloadMaxAge: 30 * 1000
}); };
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var bakers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, bakers_1.fetchAllBakers)()];
            case 1:
                bakers = _a.sent();
                return [2 /*return*/, { bakers: bakers }];
        }
    });
}); };
var hydrate = function (data) {
    if (!data || typeof data !== "object")
        return;
    var bakers = data.bakers;
    if (!bakers || typeof bakers !== "object" || !Array.isArray(bakers))
        return;
    (0, bakers_1.hydrateBakers)(bakers);
};
var currencyBridge = {
    getPreloadStrategy: getPreloadStrategy,
    preload: preload,
    hydrate: hydrate,
    scanAccounts: scanAccounts
};
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    estimateMaxSpendable: estimateMaxSpendable,
    getTransactionStatus: getTransactionStatus,
    sync: sync,
    receive: receive,
    signOperation: signOperation_1.signOperation,
    broadcast: broadcast
};
exports["default"] = { currencyBridge: currencyBridge, accountBridge: accountBridge };
//# sourceMappingURL=js.js.map